import { ProductFilter } from '../filters/product-filter';

export class HighGuideFilter extends ProductFilter {
  id: string;
  entityId: number;
  name: string;
  iconData: string;
  primaryColor: string;
  secondaryColor: string;
  dateCreated: number;
  filterCriteria: ProductFilter;

  override onDeserialize() {
    super.onDeserialize();
    window?.injector?.Deserialize?.instanceOf(ProductFilter, this.filterCriteria);
  }
}
